changeUserAccountPlanTypeProcessing